import React, { useEffect, useRef, useState } from 'react';

const COEFF_FIELDS = [
    { field: 'a2', label: 'a₂' },
    { field: 'a1', label: 'a₁' },
    { field: 'a0', label: 'a₀' },
];

const formatCoeffValue = (v) => {
    if (v === '' || v === null || v === undefined) return '';
    if (typeof v === 'string') return v;
    if (typeof v === 'number' && Number.isFinite(v)) return String(v);
    return String(v);
};

const buildDraftFromValues = (values = {}) => (
    COEFF_FIELDS.reduce((acc, { field }) => {
        acc[field] = formatCoeffValue(values[field]);
        return acc;
    }, {})
);

const FuelEquation = ({ values = {}, onChange, disabled }) => {
    const [draft, setDraft] = useState(() => buildDraftFromValues(values));
    const skipSyncRef = useRef(false);
    const focusedFieldRef = useRef(null);
    const lastExternalDraftRef = useRef(JSON.stringify(buildDraftFromValues(values)));

    useEffect(() => {
        if (skipSyncRef.current || focusedFieldRef.current) {
            skipSyncRef.current = false;
            return;
        }
        const nextDraft = buildDraftFromValues(values);
        const serialized = JSON.stringify(nextDraft);
        if (serialized !== lastExternalDraftRef.current) {
            lastExternalDraftRef.current = serialized;
            setDraft(nextDraft);
        }
    }, [values]);

    const handleChange = (field, raw) => {
        const next = { ...draft, [field]: raw ?? '' };
        skipSyncRef.current = true;
        lastExternalDraftRef.current = JSON.stringify(next);
        setDraft(next);
        onChange(field, raw ?? '');
    };

    return (
        <div className="fp-equation-coeff-grid">
            {COEFF_FIELDS.map(({ field, label }) => (
                <div key={field} className="fp-equation-coeff-item">
                    <span className="fp-equation-coeff-label">{label}</span>
                    <input
                      type="text"
                      inputMode="decimal"
                      autoComplete="off"
                      spellCheck={false}
                      className="fp-equation-coeff-input"
                      placeholder="0"
                      value={draft[field] ?? ''}
                      onChange={(e) => handleChange(field, e.target.value)}
                      onFocus={() => { focusedFieldRef.current = field; }}
                      onBlur={() => { focusedFieldRef.current = null; }}
                      disabled={disabled}
                    />
                </div>
            ))}
        </div>
    );
};

export default FuelEquation;
